import { useFilterSearchParams } from "@/utils/hooksUtils";
import { DEFAULT_POSTPONED_COMMISSIONS_QUERY_PARAMS } from "../api";
import { PostponedCommissionsFilterView } from "../components/views/PostponedCommissionsFilterView";
import { PostponedCommissionsTableView } from "../components/views/PostponedCommissionsTableView";
import { PostponedCommissionsFilterPageRequest } from "../types";

export const PostponedCommissionListContainer = () => {
  const searchParams = useFilterSearchParams<PostponedCommissionsFilterPageRequest>({
    params: ["report", "postponementReasons", "institutionIds", "orderBy", "orderDirections"],
    defaultQueryParamsObject: DEFAULT_POSTPONED_COMMISSIONS_QUERY_PARAMS,
  });

  return (
    <>
      <PostponedCommissionsFilterView searchParams={searchParams} />

      <PostponedCommissionsTableView searchParams={searchParams} />
    </>
  );
};
